import PanoViewer from "./PanoViewer";
import { VERSION } from "../version";

export default {
  PanoViewer,
  VERSION,
};
